<template>
    <div class="app-error items-center justify-center">
        <AonCard>
            <img class="mt-sm mb-md" src="@/assets/svgs/aon-logo.svg" alt="Aon (Logo)" />
            <hr />
            <p class="mt-lg extra-large">
                {{ t('error.headerPrimary') }}
            </p>
            <p class="my-lg text-moat-900 large">
                {{ t('error.headerSecondary') }}
            </p>
            <p>{{ t('error.emailText') }}</p>
            <a :href="`${emailLink}`" target="_blank">
                {{ emailText }}
            </a>
            <div class="mt-xxl">
                <router-link class="mr-xl" :to="{ name: 'Home' }">
                    <AonButton :label="`< ${t('navigationText.backButtonText')}`" />
                </router-link>
                <router-link to="/logout">
                    {{ t('navigationText.logout') }}
                </router-link>
            </div>
        </AonCard>
    </div>
</template>

<script setup>
// TODO refactor the 404, error and permissionRedirect views to use a contextable component instead
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({})
const emailText = computed(() => t('support.emailLink'))
const emailLink = computed(() => `mailto:${emailText.value.toLowerCase()}`)
</script>

<style scoped lang="scss">
.app-error {
    display: flex;
    height: 100%;

    .a-card {
        width: 30vw;
        margin: auto;
        text-align: center;

        hr {
            color: var(--color-stone-200);
        }
    }
}
</style>
